<template>
  <InputComponent
    v-if="value"
    :label="$t('customFieldsUnitTemplatesLabel')"
    :sublabel="$attrs.sublabel"
    class="field-residentialtemplate"
  >
    <div class="field-residentialtemplate__content elder-input__element">
      <RichText v-model="value.description" :label="$t('description')" />
      <InputComponent :label="$tc('unitTemplate', 2)">
        <template #default>
          <Loader :value="promise">
            <Selector
              v-model="references"
              :items="getResidentialTemplates"
              multiple
              search
              class="elder-input__element"
            >
              <template #item="{ item }">
                <Card :value="item" />
              </template>
              <template #empty>
                <Card :value="{ name: $t('select') }" />
              </template>
              <template #noresults="{ filter }">
                <div class="text--center">
                  {{ $t('couldnotfindonquery', { query: filter.search }) }}
                </div>
              </template>
            </Selector>
          </Loader>
        </template>
      </InputComponent>
    </div>
  </InputComponent>
</template>

<script>
import { Clone } from '../utils'
import { getResidentialTemplates } from '../api'
import Template from '../Templates/ResidentialTemplate'

import Selector from '@kvass/selector'
import RichText from './RichText'
import { InputComponent } from 'vue-elder-input'
import { LoaderComponent as Loader } from 'vue-elder-loader'
import Card from '../components/ResidentialTemplate/Card'

export default {
  props: {
    label: String,
    value: Object,
  },
  watch: {
    'value.references': {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      data: [],
      promise: null,
    }
  },
  computed: {
    references: {
      get() {
        if (!this.value) return []
        return this.value.references.map(r => this.data.find(d => d.id === r)).filter(Boolean)
      },
      set(val) {
        return (this.value.references = val.map(v => v.id))
      },
    },
  },
  methods: {
    getResidentialTemplates(filter) {
      return getResidentialTemplates({ filter })
    },
    fetch() {
      if (!this.value || !this.value.references.length) return
      this.promise = getResidentialTemplates({ ids: this.value.references }).then(
        data => (this.data = data),
      )
    },
  },
  created() {
    if (!this.value) this.$emit('input', Clone(Template))
  },
  components: {
    RichText,
    Selector,
    InputComponent,
    Card,
    Loader,
  },
}
</script>

<style lang="scss">
.field-renderer--residentialtemplate {
  grid-column-end: span 2;
}

.field-residentialtemplate {
  &__content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem 2rem;
  }
}
</style>
